const mainMenuToggle = document.getElementById('menu-toggle');
const mainMenu = document.getElementById('header-menu');
const mobileMenuIcons = document.querySelectorAll('.header__menu-mobile-ico');

if(mainMenuToggle && mainMenu && mobileMenuIcons) {
    mainMenuToggle.addEventListener('click', () => {
        mainMenu.classList.toggle('header__menu--hide');
        mobileMenuIcons.forEach(element => {
            element.classList.toggle('header__menu-mobile-ico--active');
        })
    })
}